import React from 'react'

function NotFound() {
    return (
        <div id="wrapper" style={{ margin: 'auto', maxWidth: '500px', textAlign: 'center' }} >
            <img src="https://i.imgur.com/qIufhof.png" width={400} height={300} />
            <div id="info">
                <h3>This page could not be found</h3>
            </div>
        </div >
    )
}

export default NotFound